/* eslint-disable react/prop-types */ // TODO: add props
import style from './Serial.scss';

function Serial({ checklistItemSerial }) {
  return (
    <span className={style.serial} data-serial={checklistItemSerial}>
      {checklistItemSerial}
    </span>
  );
}

export default Serial;
